import React from 'react'
import PropTypes from 'prop-types'
import ErrorNotFoundPage from '~/components/Error/NotFound/Page'
import useGiftFlowIsActive from '~/hooks/components/use-gift-flow-is-active'

const GiftFlowFeatureFlag = ({ location, children }) => {
  const giftFLowIsActive = useGiftFlowIsActive(location?.search)

  return <>{giftFLowIsActive ? children : <ErrorNotFoundPage />}</>
}

GiftFlowFeatureFlag.propTypes = {
  location: PropTypes.object,
  children: PropTypes.node
}

export default GiftFlowFeatureFlag
